import { Paper } from '@mui/material';

import useChartOptions from '@/components/Chart/hooks/options/useChartOptions';
import useSpotOptions from '@/components/Chart/hooks/options/useSpotOptions';
import RegularChart from '@/components/Chart/RegularChart';
import useUserDetails from '@/hooks/useUserDetails';
import useDhChart from '@/pages/DataHub/Chart/useDhChart';

const SummaryChart = () => {
  const { isUserExpired, isUserBasic } = useUserDetails();
  const { chartSeries, error, loading, chartHeight } = useDhChart(true);
  const { createOptions } = useSpotOptions(chartHeight, true);
  const { options: chartOptions } = useChartOptions(chartSeries, createOptions);

  return (
    <Paper sx={{ p: 2, flex: 1, position: 'relative' }}>
      <RegularChart
        chartSeries={chartSeries}
        error={error}
        height={chartHeight}
        loading={loading && !(isUserExpired || isUserBasic)}
        options={chartOptions}
      />
    </Paper>
  );
};

export default SummaryChart;
